/*
* @描述: 表单模版
*/
<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="formTplDialog"
        custom-class="form-tpl-dialog"
        :title="formTplTitle"
        width="776px"
        :before-close="handleDialogClose"
    >
        <div class="form-tpl-dialog-content">
            <p class="form-tpl-dialog-tip">
                {{ formTplDesc }}
            </p>
            <ul>
                <li v-for="item in formTplList" :key="item.id">
                    <p>
                        <i class="iconfont icon-gengduogongneng_xuanzhong"></i><span>{{ item.title }}</span>
                    </p>
                    <p>{{ item.desc }}</p>
                    <div>
                        <p>{{ item.secTitle }}</p>
                        <div :class="'form-tpl-box' + item.type">
                            <img :src="item.thumbnail" alt="" />
                        </div>
                    </div>
                    <div class="form-tpl-btns">
                        <el-button type="primary" plain @click="handleClickTplPreview(item)">预览</el-button>
                        <el-button type="primary" @click="handleClickTplUse(item)">使用</el-button>
                    </div>
                </li>
            </ul>
        </div>
        <el-dialog
            v-if="formTplPreviewDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="formTplPreviewTitle"
            :visible.sync="formTplPreviewDialog"
            :append-to-body="true"
            custom-class="form-tpl-preview-dialog"
            width="680px"
        >
            <div class="form-tpl-preview-dialog-content" v-loading="formTplLoading">
                <p>{{ formTplPreviewDesc }}</p>
                <div class="form-tpl-preview-carousel">
                    <div class="form-tpl-preview-form-box">
                        <div class="form-tpl-preview-form-wrap">
                            <p class="form-tpl-preview-form-title">{{ field_form_title }}</p>
                            <CustomFormPc
                                :field_list="formInfoList"
                                ref="crm_custom_form"
                                :pk_id="formTplPreviewType"
                                v-if="dataLoaded"
                            />
                        </div>
                    </div>
                    <div
                        class="carousel-left"
                        :class="{ disabled: formTplPreviewType == 1 }"
                        @click="handleClickFormTplChange('left')"
                    >
                        <i class="el-icon-arrow-left"></i>
                    </div>
                    <div
                        class="carousel-right"
                        :class="{ disabled: formTplPreviewType == formTplList.length }"
                        @click="handleClickFormTplChange('right')"
                    >
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
                <div class="form-tpl-preview-dialog-bottom">
                    <p>{{ formTplList.find((item) => item.type == formTplPreviewType).desc }}</p>
                    <el-button
                        type="primary"
                        size="small"
                        @click="handleClickTplUse(formTplList.find((item) => item.type == formTplPreviewType))"
                        >使用该模版</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import { getFormFields } from "@/api";
export default {
    name: "FormTplSelect",
    components: { CustomFormPc },
    props: {
        formTplDialog: {
            type: Boolean,
            default: false,
        },
        formTplTitle: {
            type: String,
            default: "表单模版",
        }, // 模版列表的标题
        formTplDesc: {
            type: String,
            default: "",
        }, // 模版列表的描述
        formTplList: {
            type: Array,
            default: [],
        }, // 模版列表
        field_form: {
            type: String,
            default: "",
        }, // 表单类型
        field_form_title: {
            type: String,
            default: "",
        }, // 表单类型名称
        formTplPreviewDesc: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            formTplPreviewDialog: false,
            formTplPreviewType: 1,
            formTplLoading: false,
            dataLoaded: false,
        };
    },
    computed: {
        formTplPreviewTitle() {
            let title = "";
            switch (this.formTplPreviewType) {
                case 1:
                    title = "模版一";
                    break;
                case 2:
                    title = "模版二";
                    break;
                case 3:
                    title = "模版三";
                    break;
                case 4:
                    title = "模版四";
                    break;
                default:
                    title = "模版一";
                    break;
            }
            return title;
        },
    },
    methods: {
        // 弹框关闭
        handleDialogClose() {
            this.$emit("update:formTplDialog", false);
        },
        //表单字段获取
        _getFromFields() {
            getFormFields({
                field_form: this.field_form,
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    this.dataLoaded = true
                }
                this.formTplLoading = false
            }).catch(()=> {
                this.formTplLoading = false
            })
        },
        // 模版预览
        handleClickTplPreview(item) {
            this.formTplPreviewDialog = true;
            this.formTplLoading = true
            this.formTplPreviewType = item.type;
            this._getFromFields();
        },
        // 模版使用
        handleClickTplUse(item) {
            this.$emit("update:formTplDialog", false);
            this.$emit("tplUseSuccess", item);
        },
        // 模版切换
        handleClickFormTplChange(type) {
            if (
                (this.formTplPreviewType == 1 && type == "left") ||
                (this.formTplPreviewType == this.formTplList.length && type == "right")
            )
                return;
            this.formTplLoading = true;
            if (type == "left") {
                if (this.formTplPreviewType > 1) {
                    this.formTplPreviewType--;
                } else {
                    this.formTplPreviewType = 1;
                }
            } else {
                if (this.formTplPreviewType < this.formTplList.length) {
                    this.formTplPreviewType++;
                } else {
                    this.formTplPreviewType = this.formTplList.length;
                }
            }
            setTimeout(() => {
                this.formTplLoading = false;
            }, 500);
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep {
    .form-tpl-dialog {
        .el-dialog__body {
            min-height: 446px;
            max-height: 620px;
            border-radius: 8px;
            background: rgba(247, 248, 250, 1);
            box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08);
            padding: 24px 17px;
            overflow-y: auto;
        }

        .form-tpl-dialog-tip {
            width: 100%;
            height: 38px;
            text-align: center;
            line-height: 38px;
            opacity: 1;
            border-radius: 4px;
            background: rgba(237, 240, 244, 1);
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(102, 102, 102, 1);
        }

        .form-tpl-dialog-content {
            ul {
                width: 100%;
                display: flex;
                flex-wrap: wrap;

                li {
                    width: 232px;
                    border-radius: 6px;
                    margin-top: 16px;
                    margin-right: 16px;
                    background: rgba(255, 255, 255, 1);
                    padding: 16px;
                    position: relative;
                    cursor: pointer;
                    transition: 0.3s all;
                    box-sizing: border-box;
                    &:nth-of-type(3n) {
                        margin-right: 0;
                    }

                    p:nth-child(1) {
                        font-size: 14px;
                        font-weight: 700;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(51, 51, 51, 1);
                        display: flex;
                        gap: 9px;

                        .iconfont {
                            font-size: 15px;
                            color: rgba(41, 144, 255, 1);
                        }
                    }

                    p:nth-child(2) {
                        margin-top: 4px;
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(102, 102, 102, 1);
                    }

                    & > div {
                        margin-top: 12px;
                        padding: 4px;
                        height: 230px;
                        border-radius: 4px;
                        background: rgba(237, 240, 244, 1);

                        & > p {
                            height: 35px;
                            padding: 8px 12px;
                            font-size: 12px;
                            font-weight: 400;
                            letter-spacing: 0px;
                            line-height: 18px;
                            color: rgba(51, 51, 51, 1);
                            background-color: rgba(255, 255, 255, 1);
                            border-radius: 4px 4px 0 0;
                            border-bottom: 1px solid rgba(232, 232, 232, 1);
                        }

                        & > div {
                            padding: 0;
                            background-color: rgba(255, 255, 255, 1);
                            border-radius: 0 0 4px 4px;
                            height: 187px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }

                    .form-tpl-btns {
                        display: none;
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        height: 52px;
                        opacity: 1;
                        border-radius: 0px 0px, 6px, 6px;
                        background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.01) 100%);
                        padding: 10px 0;
                        text-align: center;

                        .el-button {
                            display: inline-block;
                            vertical-align: top;
                            padding: 0;
                            width: 84px;
                            height: 32px;
                            text-align: center;
                            line-height: 32px;

                            & + .el-button {
                                margin-left: 16px;
                            }
                        }
                    }

                    &:hover {
                        box-shadow: 0px 6px 16px 4px rgba(0, 0, 0, 0.08);

                        .form-tpl-btns {
                            display: block;
                        }
                    }
                }
            }
        }
    }

    .form-tpl-preview-dialog {
        .el-dialog__header {
            padding-bottom: 0;
            border-bottom: none;
        }

        .el-dialog__body {
            padding: 0;
        }

        .form-tpl-preview-dialog-content {
            padding-top: 4px;

            & > p:nth-child(1) {
                padding: 0 24px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(153, 153, 153, 1);
            }

            .form-tpl-preview-carousel {
                padding: 12px 0 0;
                position: relative;
            }

            .form-tpl-preview-form-box {
                width: 560px;
                height: 564px;
                padding: 8px;
                border-radius: 7px;
                background-color: rgba(237, 240, 244, 1);
                margin: 0 auto;
                .form-tpl-preview-form-wrap {
                    width: 100%;
                    height: 100%;
                    background-color: #ffffff;
                    border-radius: 6px;
                    .form-tpl-preview-form-title {
                        padding: 12px 16px;
                        font-size: 16px;
                        font-weight: 700;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(34, 34, 34, 1);
                        border-bottom: 1px solid rgba(232, 232, 232, 1);
                    }
                }
                .custom_form_wrap {
                    padding: 16px;
                    height: calc(100% - 50px);
                    background-color: #ffffff;
                    overflow-y: scroll;
                }
            }
            .carousel-left,
            .carousel-right {
                width: 24px;
                height: 24px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(217, 217, 217, 1);
                border-radius: 50%;
                position: absolute;
                top: 50%;
                margin-top: -12px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                i {
                    font-size: 8px;
                    color: rgba(102, 102, 102, 1);
                    font-weight: 800;
                }
                &:hover {
                    border-color: rgba(75, 162, 255, 1);
                    i {
                        color: rgba(75, 162, 255, 1);
                    }
                }
                &:active,
                &.acitve {
                    border-color: rgba(34, 121, 214, 1);
                    i {
                        color: rgba(34, 121, 214, 1);
                    }
                }
                &.disabled {
                    cursor: not-allowed;
                    background: rgba(247, 247, 247, 1);
                    border-color: rgba(217, 217, 217, 1);
                    i {
                        color: rgba(191, 191, 191, 1);
                    }
                }
            }
            .carousel-left {
                left: 24px;
            }
            .carousel-right {
                right: 24px;
            }
        }

        .form-tpl-preview-dialog-bottom {
            height: 64px;
            padding: 0 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            p {
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(102, 102, 102, 1);
            }

            .el-button {
                font-size: 14px;
                font-weight: 400;
            }
        }
    }
}
</style>
